import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";

import { PALE_BLUE, BLACK_075 } from "../../../styles/colors";
import modalState from "../../../state-observables/modal/ModalState";
import openNewTab from "../../../utils/open-new-tab";
import SimpleButton from "../../disposables/buttons/SimpleButton";
import { setAnalyticsConsentWithTracking } from "../../../utils/analytics";

const AnalyticsConsentModal = () => {
  const { t } = useTranslation();

  const onConsent = async (consentDecision: boolean) => {
    await setAnalyticsConsentWithTracking(consentDecision);
    modalState.closeModal(consentDecision);
  };

  return (
    <div className={styles.analyticsConsentModalContainer}>
      <div className={styles.analyticsConsentModalInfoContainer}>
        <p className={styles.analyticsConsentModalInfoParagraph}>
          {t('analytics.info_1')}
        </p>
        <p className={styles.analyticsConsentModalInfoParagraph}>
          {t('analytics.info_2')}
        </p>
        <p className={styles.analyticsConsentModalInfoParagraph}>
          {t('analytics.info_3')}
        </p>
      </div>
      <div className={styles.analyticsConsentModalButtonsContainer}>
        <div className={styles.analyticsConsentModalButtonsYesButton}>
          <SimpleButton
            title={t('analytics.accept')}
            onClick={() => onConsent(true)}
            titleSize="2.5rem"
          />
        </div>
        <div className={styles.analyticsConsentModalButtonsNoButton}>
          <SimpleButton
            title={t('analytics.reject')}
            onClick={() => onConsent(false)}
            titleSize="1.5rem"
          />
        </div>
        <div className={styles.analyticsConsentModalButtonsInfoButton}>
          <SimpleButton
            title={t('analytics.more_info')}
            onClick={() =>
              openNewTab("https://marty-webapp.web.app/privacy-policy")
            }
            titleSize="1.5rem"
            textColour={BLACK_075}
            colour={PALE_BLUE}
          />
        </div>
      </div>
    </div>
  );
};

export default AnalyticsConsentModal;
